import { get, set } from 'lodash';

declare const FALLBACK_LOCALE

export interface TranslatedString {
    translatedString: Record<string, string | null>;
}

export interface Translation {
    i18nId: string,
    lang: string,
    message: Record<string, any>,
}

export function getTranslatedString(value, locale, fallbackLocale: string = FALLBACK_LOCALE) {
    let fragment = get(value, ['translatedString', locale], "");
    if (!fragment && fallbackLocale) {
        fragment = get(value, ['translatedString', fallbackLocale], "");
    }
    return fragment;
}

export function createTranslatedString(locale, defaultValue: string | null = null) {
    return { translatedString: { [locale]: defaultValue } };
}

export function createTranslatedStringArray(locale: string, values: string[]) {
    return values.map(
        value => createTranslatedString(locale, value)
    )
}

export function editTranslatedString(translatedString: TranslatedString, value: string, locale) {
    set(translatedString, ['translatedString', locale], value)
}